module.exports = __webpack_public_path__ + "img/service-NDW2.f0ccebba.svg";